import Styles from './ReferenceImageButton.module.scss'
import { forwardRef } from 'react'
import { AriaLabelingProps } from '@react-types/shared'
import { filterDOMProps, useObjectRef } from '@react-aria/utils'
import { useButton } from '@react-aria/button'
import { ReferenceImageButtonProps } from 'screens/Schedule/PostPromptsSection/Types'
import { Text } from 'blaze-ui/Text/Text'
import { Edit1 } from 'blaze-ui/icons'
import { ReferenceImg } from 'screens/Schedule/PostPromptsSection/ReferenceImg'
import { isVideoReferenceMedia } from 'screens/Schedule/PostPromptsSection/referenceMedia'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'

export const ReferenceImageButton = forwardRef<HTMLButtonElement, ReferenceImageButtonProps & AriaLabelingProps>(
  ({ referenceMediaFile, topicGenerated, width = 175, height = 175, label, ...props }, fRef) => {
    const ref = useObjectRef(fRef)
    const { buttonProps } = useButton(props, ref)

    const isVideo = isVideoReferenceMedia(referenceMediaFile)
    const previewSrc = isVideo
      ? referenceMediaFile.thumbnail_url || referenceMediaFile.source_url || ''
      : referenceMediaFile.source_url || ''
    const defaultLabelText = isVideo ? 'Reference Video' : 'Reference Image'

    return (
      <button {...buttonProps} {...filterDOMProps(props, { labelable: true })} className={Styles.referenceImage}>
        <ReferenceImg
          src={previewSrc}
          alt={label ?? defaultLabelText}
          width={width}
          height={height}
          topicGenerated={topicGenerated}
        />
        {isVideo && referenceMediaFile.duration != null && (
          <VideoDuration duration={referenceMediaFile.duration} containerClassName={Styles.durationTopRight} />
        )}
        <div className={Styles.label}>
          <Text color="var(--light-100)" lineClamp={1} variant="secondary">
            {label ?? defaultLabelText}
          </Text>
          <Edit1 color="var(--light-100)" size={15} />
        </div>
      </button>
    )
  },
)
